// Shared template-preview HTML builder (SuggestionPanel + admin TemplatesPage
// previously each had their own copy). Decodes entity-encoded content, lays
// the template out exactly as the Templates editor shows it, and — the important part — runs the
// result through DOMPurify before it ever reaches dangerouslySetInnerHTML.
// Template content is admin-authored, not buyer input, but the template store
// is still a stored-XSS vector into every CSR's browser (which holds a live
// API session) — sanitize regardless of the source.
import DOMPurify from 'dompurify'
import { toEditableHtml } from './richTextConversion.js'

function decodeHtmlEntities(s) {
  const ta = document.createElement('textarea')
  ta.innerHTML = s
  return ta.value
}

// The preview lays a template out exactly as the Templates editor shows it
// (2026-10-28, Jenn; docs/decisions/2026-10-28-template-text-as-editor-shows.md):
// the same toEditableHtml() the editor loads it with, so a plain-text body's
// blank line is a paragraph and its single newline a <br>, and an HTML body
// keeps its own <p>/<br>. Nothing is doubled. PREVIEW_PARAGRAPH_SX gives a
// paragraph the editor's gap (TemplateRichEditor.jsx's '& p' margin).
export function previewHtml(content) {
  const decoded = decodeHtmlEntities(content ?? '')
  return DOMPurify.sanitize(toEditableHtml(decoded))
}

// The editor's paragraph and list spacing, for a preview container's sx.
export const PREVIEW_PARAGRAPH_SX = Object.freeze({
  '& p': { margin: '0 0 1em', minHeight: '1.2em' },
  '& p:last-child': { marginBottom: 0 },
  '& ul, & ol': { margin: '0 0 1em', paddingLeft: '1.5em' },
})
